import React, { useState, useEffect } from 'react';
import { Select, HStack } from '@chakra-ui/react';
import dayjs from 'dayjs';

interface DateOfBirthSelectProps {
  value?: string | null;
  onChange: (value: string) => void;
}

const DateOfBirthSelect: React.FC<DateOfBirthSelectProps> = ({ value, onChange }) => {
  const parsed = value ? dayjs(value) : null;

  const [day, setDay] = useState<string>(parsed && parsed.isValid() ? parsed.date().toString().padStart(2, '0') : '');
  const [month, setMonth] = useState<string>(parsed && parsed.isValid() ? (parsed.month() + 1).toString().padStart(2, '0') : '');
  const [year, setYear] = useState<string>(parsed && parsed.isValid() ? parsed.year().toString() : '');

  useEffect(() => {
    if (value) {
      const d = dayjs(value);
      if (d.isValid()) {
        setDay(d.date().toString().padStart(2, '0'));
        setMonth((d.month() + 1).toString().padStart(2, '0'));
        setYear(d.year().toString());
      }
    }
  }, [value]);

  useEffect(() => {
    if (day && month && year) {
      const formatted = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      onChange(formatted);
    }
  }, [day, month, year, onChange]);

  const days = Array.from({ length: 31 }, (_, i) => (i + 1).toString().padStart(2, '0'));
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 121 }, (_, i) => (currentYear - i).toString());

  return (
    <HStack spacing={2} width="100%">
      <Select placeholder="Day" value={day} onChange={(e) => setDay(e.target.value)} borderRadius="30px">
        {days.map((d) => (
          <option key={d} value={d}>
            {d}
          </option>
        ))}
      </Select>
      <Select placeholder="Month" value={month} onChange={(e) => setMonth(e.target.value)} borderRadius="30px">
        {months.map((m, i) => {
          const val = (i + 1).toString().padStart(2, '0');
          return (
            <option key={m} value={val}>
              {m}
            </option>
          );
        })}
      </Select>
      <Select placeholder="Year" value={year} onChange={(e) => setYear(e.target.value)} borderRadius="30px">
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </Select>
    </HStack>
  );
};

export default DateOfBirthSelect;
